import TimerRing from "../../components/ui/TimerRing";
import ScenarioTracker from "../../components/ui/ScenarioTracker";
import NotificationBadge from "../../components/ui/NotificationBadge";
import MissionPanel from "../../components/ui/MissionPanel";
import PersonalNotes from "../../components/ui/PersonalNotes";
import SharedPanel from "../../components/ui/SharedPanel";

export default function GameDrawerSession({
  onClose,
  timeLeft, formatTime, sessionDuration,
  code, me,
  toggleHandRaise, myHandRaised,
  voteGateActive, setAdvanceModalOpen, myVote, waitingCount,
  leftTab, setLeftTab, setNotif, notif, leftTabRef,
  state, missionGuide, missionFilter, setMissionFilter,
  inventory,
}) {
  return (
    <div className="fixed inset-0 z-50 [@media(min-width:1420px)]:hidden">
      <div className="absolute inset-0 bg-black/60" onClick={onClose} />
      <div className="absolute left-0 top-0 bottom-0 w-80 max-w-[90vw] flex flex-col overflow-hidden"
        style={{ background: "#04050f", borderRight: "1px solid rgba(255,255,255,.07)" }}>

        <div style={{ padding: "14px 16px 10px", borderBottom: "1px solid rgba(255,255,255,.06)", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ fontSize: 9, letterSpacing: ".2em", textTransform: "uppercase", color: "rgba(6,182,212,.7)", fontWeight: 700, fontFamily: "ui-monospace,monospace" }}>
            ◈ PROJET ORIGAMI
          </div>
          <button onClick={onClose}
            style={{ width: 28, height: 28, borderRadius: 6, border: "1px solid rgba(255,255,255,.08)", background: "rgba(255,255,255,.04)", color: "rgba(148,163,184,.8)", fontSize: 11, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>
            ✕
          </button>
        </div>

        <div style={{ padding: "10px 14px 8px", borderBottom: "1px solid rgba(255,255,255,.04)" }}>
          <TimerRing timeLeft={timeLeft} formatTime={formatTime} totalSeconds={sessionDuration} />
        </div>

        <div style={{ padding: "8px 14px", borderBottom: "1px solid rgba(255,255,255,.04)" }}>
          <div className="hud-jrn-card"><ScenarioTracker sessionCode={code} /></div>
        </div>

        <div style={{ padding: "8px 14px", borderBottom: "1px solid rgba(255,255,255,.04)", display: "flex", gap: 6 }}>
          <button onClick={toggleHandRaise}
            className={`hud-abtn ${myHandRaised ? "hud-abtn-hand-active" : "hud-abtn-hand"}`}>
            ✋ Lever la Main
          </button>
          {voteGateActive && (
            <button type="button" onClick={() => setAdvanceModalOpen(true)} className="hud-abtn hud-abtn-vote">
              🗳 Vote <span className="hud-vote-badge">{myVote === "yes" ? "OK" : myVote === "no" ? "⛔" : waitingCount}</span>
            </button>
          )}
        </div>

        <div className="hud-tab-bar" style={{ flexShrink: 0 }}>
          {[{ id: "mission", label: "Mission" }, { id: "notes", label: "Notes" }, { id: "shared", label: "Partagés" }].map(t => (
            <button key={t.id} type="button"
              onClick={() => { setLeftTab(t.id); setNotif(n => ({ ...n, [t.id]: 0 })); }}
              className={`hud-tab ${leftTab === t.id ? "hud-tab-on" : ""}`}
              style={{ position: "relative" }}>
              {t.label}
              {leftTab !== t.id && <NotificationBadge count={notif[t.id]} />}
            </button>
          ))}
        </div>

        <div style={{ flex: 1, minHeight: 0, overflowY: "auto", padding: "10px 14px" }} className="custom-scrollbar">
          {leftTab === "mission" && (
            <MissionPanel stage={state.stage || 1} items={missionGuide} filter={missionFilter} onFilterChange={setMissionFilter} />
          )}
          {leftTab === "notes" && <PersonalNotes storageKey={`notes:${code}:${me.id}`} />}
          {leftTab === "shared" && (
            <SharedPanel sessionCode={code} playerId={me.id}
              onNewShared={(delta) => {
                if (leftTabRef.current === "shared") return;
                setNotif(n => ({ ...n, shared: n.shared + (delta || 1) }));
              }}
            />
          )}
        </div>

        <div className="hud-inv" style={{ flexShrink: 0 }}>
          <div className="hud-inv-dot" />
          <div className="hud-inv-txt">{inventory[me.id]?.hasKeyJ4 ? "🔑 Clé du dictionnaire" : "Inventaire vide"}</div>
        </div>
      </div>
    </div>
  );
}